import axios from 'axios';

let baseURL = process.env.VUE_APP_API_BASE_URL;
baseURL = baseURL.endsWith('/') ? baseURL : `${baseURL}/`;

const nopInstance = axios.create({
  baseURL,
});

// Add an interceptor to automatically extract the Data property from the response object
nopInstance.interceptors.response.use(
  (response) => {
    if (response?.data) {
      return response.data;
    }
    handleError('No data in response');
  },
  (error) => handleError(error),
);

const handleError = (error) => {
  console.log(error);
  throw error;
};

export default nopInstance;
